import { queryOptions } from '@tanstack/react-query'

import { getFirebaseStorageUrl } from '@/lib/firebase-storage'

export const firebaseStorageUrlQuery = (storagePath: string | null | undefined, scope?: string) =>
  queryOptions({
    queryKey: scope
      ? (['firebase-storage-url', storagePath, scope] as const)
      : (['firebase-storage-url', storagePath] as const),
    // getFirebaseStorageUrl resolves every failure to null, a dropped connection as much as a missing
    // object. Cached as a success, that null would stand for an hour after the network came back;
    // as an error, the next mount or window focus asks again.
    queryFn: async () => {
      const url = await getFirebaseStorageUrl(storagePath)
      if (!url) {
        throw new Error(`No download URL for ${storagePath}`)
      }
      return url
    },
    enabled: !!storagePath,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 2,
    retry: 1,
  })
